var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24663 14.187C4.71996 14.187 4.21996 14.0603 3.77996 13.807C2.73996 13.207 2.16663 11.987 2.16663 10.3803V5.62698C2.16663 4.01365 2.73996 2.80032 3.77996 2.20032C4.81996 1.60032 6.15996 1.71365 7.55996 2.52032L11.6733 4.89365C13.0666 5.70032 13.84 6.80699 13.84 8.00699C13.84 9.20699 13.0733 10.3137 11.6733 11.1203L7.55996 13.4937C6.75329 13.9537 5.96663 14.187 5.24663 14.187ZM5.24663 2.81365C4.88663 2.81365 4.56663 2.89365 4.27996 3.06032C3.55996 3.47365 3.16663 4.38698 3.16663 5.62698V10.3737C3.16663 11.6137 3.55996 12.5203 4.27996 12.9403C4.99996 13.3603 5.98663 13.2403 7.05996 12.6203L11.1733 10.247C12.2466 9.62699 12.84 8.83365 12.84 8.00032C12.84 7.16699 12.2466 6.37365 11.1733 5.75365L7.05996 3.38032C6.40663 3.00699 5.79329 2.81365 5.24663 2.81365Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.715e22de2d16861b197d6eef6bc32414.svg";
export { ForwardRef as ReactComponent };